import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H1, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const GoPremiumCard = () => {
  return (
    <Col xl="5" md="6">
      <Card className="welcome-card">
        <CardBody>
          <div className="d-flex">
            <div className="flex-grow-1">
              <H1>{`Good day, Lena Miller`}</H1>
              <P>{`Welcome to the Admin clan! We appreciate your interest in our dashboard.`}</P>
              <Link className="btn" to={`${process.env.PUBLIC_URL}/applications/ecommerce/product_list`}>
                {`Go Premium`}
              </Link>
            </div>
            <div className="flex-shrink-0">
              <Image src={dynamicImage(`dashboard/boxes.png`)} alt="" />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GoPremiumCard;
